/* eslint no-console: "off" */
var isEnabled = false;
export function enableDebugLog() {
  isEnabled = true;
}
export function log(msg) {
  if (!isEnabled) return;
  console.log(msg);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tus-js-client/lib.esm/logger.js
// module id = 483
// module chunks = 0